import React from 'react';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import RestaurantStatisticsPage from 'modules/restaurant/statistics/RestaurantStatisticsPage';

export default function DashRestaurantStatistics() {
    return (
        <DashContainer title='Estatísticas'>
            <RestaurantStatisticsPage />
        </DashContainer>
    );
}
